import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import { appLayoutPreferenceSlice } from './slices/appLayoutPreferenceSlice';
import { appThemeSlice } from './slices/appThemeSlice';
import { IAppStore } from './typing';
import { appGlobalSlice } from './slices/appGlobalSlice';

export const useAppStore = create<
  IAppStore,
  [['zustand/persist', unknown], ['zustand/immer', never]]
>(
  persist(
    immer((...a) => ({
      ...appThemeSlice(...a),
      ...appLayoutPreferenceSlice(...a),
      ...appGlobalSlice(...a),
    })),
    {
      name: 'app-store-preferences',
      storage: createJSONStorage(() => localStorage),
      // partialize: (state) => {
      //   if (state.themeSettings.colorPrimary?.isPersist === false) {
      //     // eslint-disable-next-line @typescript-eslint/no-unused-vars
      //     const { colorPrimary, ...rest } = state.themeSettings;
      //     return { ...state, themeSettings: rest };
      //   }
      //   return state;
      // },
    },
  ),
);
